import { Deserializable } from '../../../lib/models/deserializable';
export class KfiApplicant implements Deserializable {
  public KfiNumber: number;
  public ApplicantOrder: number;
  public CustomerType: string;
  public Forename: string;
  public ResidentialStatus: string;
  public Surname: string;
  public Title: string;
  public Order: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
